/** @format */

export const BannerAd = () => {
	return null
}

export default BannerAd
